export { default } from './Details.container';
